import React from 'react';
import styles from './skeletonLoader.module.scss';
import { SkeletonLoaderViewModel } from 'src/types/view-models/atoms/skeleton-loader.view.model';
import Selectors from 'src/utils/selectors';

export default function SkeletonLoader({ className }: SkeletonLoaderViewModel): JSX.Element {
    return <div className={`${styles.skeletonContainer} ${className}`} data-cy={Selectors.General.LOADING_INDICATOR} />;
}
